import { Box, Typography, Grid } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { BaseCard } from '../common/BaseCard';
import { DataItem } from '../common/DataItem';
import { formatDateSafe, formatCep } from '../utils/formatters';
import { IObito } from '../../../../../../application/models/dossie';

export const RegistroObitoCard = ({ obito }: { obito: IObito | null }) => {
  if (!obito || !obito.dadosFalecido) return null;

  const dadosFalecido = obito.dadosFalecido;
  const dadosCartorio = obito.dadosCartorio;

  return (
    <BaseCard title="Registro de Óbito" icon={<ErrorOutlineIcon />}>
      <Grid container spacing={4} className="obito-grid-container">
        <Grid item xs={12} lg={6} className="obito-col-1">
          <Box display="flex" flexWrap="wrap" gap={5} mb={3}>
            <Box>
              <DataItem label="Data de Óbito" value={formatDateSafe(dadosFalecido.DataObito)} />
            </Box>
            {dadosFalecido.NomePaiFalecido && (
              <Box>
                <DataItem label="Nome do Pai" value={dadosFalecido.NomePaiFalecido} />
              </Box>
            )}
          </Box>

          <Typography
            variant="caption"
            sx={{ color: '#1e293b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', mb: 2, display: 'block' }}
          >
            Documentação
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6} sm={3}>
              <DataItem label="Número Livro" value={dadosFalecido.NumeroLivro} preserveCase={true} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <DataItem label="Número Folha" value={dadosFalecido.NumeroFolha} preserveCase={true} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <DataItem label="Número Termo" value={dadosFalecido.NumeroTermo} preserveCase={true} />
            </Grid>
            <Grid item xs={6} sm={3}>
              <DataItem label="Data Lavratura" value={formatDateSafe(dadosFalecido.DataLavratura)} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} lg={6} className="obito-col-2">
          {dadosCartorio && (
            <Box
              sx={{
                p: 2.5,
                borderRadius: '12px',
                border: '1px solid #ece7f2',
                backgroundColor: '#faf8fc',
              }}
            >
              <Typography
                variant="caption"
                sx={{ color: '#1e293b', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.05em', mb: 2, display: 'block' }}
              >
                Cartório
              </Typography>
              <DataItem label="Nome do Cartório" value={dadosCartorio.NomeCartorio} />
              <DataItem label="Endereço do Cartório" value={dadosCartorio.EnderecoCartorio} />
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <DataItem
                    label="Cidade / UF"
                    value={`${dadosCartorio.Cidade || '-'} / ${dadosCartorio.Uf || '-'}`}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DataItem label="CEP do Cartório" value={formatCep(dadosCartorio.Cep)} />
                </Grid>
              </Grid>
            </Box>
          )}
        </Grid>
      </Grid>
    </BaseCard>
  );
};
